import router from './../router';
exports.install = function (Vue, options) {
       Date.prototype.Format = function (fmt) {
        var o = {
            "M+": this.getMonth() + 1,                 //月份
            "d+": this.getDate(),                    //日
            "h+": this.getHours(),                   //小时
            "m+": this.getMinutes(),                 //分
            "s+": this.getSeconds(),                 //秒
            "q+": Math.floor((this.getMonth() + 3) / 3), //季度
            "S": this.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    } 
    Vue.prototype.filterData= function(id,arr,point="-"){
        if(id == null || id == undefined ) return "";
        
        let callBackValue = [];
        id =  typeof id != 'object'? new Set([id]):new Set(id);
        arr.map(d=>{
            if(id.has(d.id)) callBackValue.push(d.name);
        });
        return callBackValue ==null? "": callBackValue.join(point);
    }

    Vue.prototype.cloneObject= function(cloneData = {},toClone = {}){
        for(let i in cloneData){
            for(let j in toClone){
                if(j == i) {
                    toClone[j] = cloneData[i];    
                }
            }
        }
        return toClone;
    }
    Vue.prototype.openWindow= function(url){
        if(url != undefined && url.indexOf('http')!=-1)
            window.open(url);
        else {
            router.push(url)
        }
    }
    Vue.prototype.openLogin= function(){
        console.log(this)
    }
}


// WEBPACK FOOTER //
// ./src/api/base.js